// MATERIAL UI
import { Grid } from "@mui/material";

interface IButtonContainer {
  children: JSX.Element | JSX.Element[];
}

/**
 * Button Container Component
 *
 * @param {JSX.Element | JSX.Element[]} children - The children to be rendered in the button container
 * @returns {JSX.Element} - A button container with the children passed in
 */
export const ButtonContainer = ({ children }: IButtonContainer): JSX.Element => {
  if (Array.isArray(children)) {
    return (
      <Grid
        container
        justifyContent="space-between"
        display="flex"
        flexDirection="row"
        item
        width="100%"
        paddingTop={3}>
        {children.map((child: JSX.Element, i: number) => {
          return (
            <Grid item key={i}>
              {child}
            </Grid>
          );
        })}
      </Grid>
    );
  }

  return (
    <Grid
      container
      justifyContent="space-between"
      display="flex"
      flexDirection="row"
      item
      width="100%"
      paddingTop={3}>
      <Grid item>{children}</Grid>
    </Grid>
  );
};
